// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"2b816874","612":"2b816874","856":"632a800d","869":"632a800d","980":"d44f6b6f"}[chunkId] + ".chunk.css";
};